<template>
    <div class="tip">
        <img src="../../..//assets/images/global/auth-fail.png" alt=""/>
        <p class = "suText">认证未通过</p>
<!--        <p class = "moText">关闭此页面，您可回到网页端重新扫码认证</p>-->
    </div>
</template>
<script>
    export default {
        created() {
            document.title = "实人认证";
        }
    }
</script>
<style lang="scss" scoped>

    .tip{
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;
        margin-top: 40%;
    }

    .tip .suText{
        font-size: 16px;
        font-weight: 500;
        color: #3D3D3D;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .tip .moText{
        font-size: 12px;
        font-weight: 400;
        color: #86909C;
    }

</style>
